import { Avatar, ListItem, makeStyles } from '@material-ui/core';
import React from 'react';

import { GetLoggedInUserQuery } from '../../../../graphql/gen/types';
import { spacings, TextSizesEnum, topBorderStyle } from '../../../../theme';
import { PlexTypography } from '../../../shared/primitives/PlexTypography';

interface Props {
  userProfile: NonNullable<GetLoggedInUserQuery['currentUser']>;
  onClick: () => void;
}

export const UserSection = React.memo(({ userProfile, onClick }: Props) => {
  const classes = useStyles();
  return (
    <ListItem className={classes.container} button selected={false} onClick={onClick}>
      <div className={classes.nameContainer}>
        <Avatar alt={userProfile.email} className={classes.avatar} src={userProfile.picture} />
        <PlexTypography className={classes.name} text={userProfile.name} size={TextSizesEnum.Normal} />
      </div>
      {/* TODO(https://github.com/all-hands-hq/source/issues/678) */}
      {/* <NotificationBadge count={21} /> */}
    </ListItem>
  );
});

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    padding: '12px 24px',
    justifyContent: 'space-between',
    ...topBorderStyle,
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatar: {
    width: 24,
    height: 24,
    marginRight: spacings.small,
  },
  name: {
    color: '#8181A5',
    fontWeight: 'bold',
  },
}));
